// extracted by mini-css-extract-plugin
export default {"button":"button_button__yn2Bn","big":"button_big__+blyy"};